import React, { Component } from 'react';
import Spinner from '../spinner/index';
import css from './index.scss';

const withLoader = loadingProp => WrappedComponent => class extends Component {
    constructor(props) {
        super(props);
        this.isLoading = this.isLoading.bind(this);
    }

    isLoading() {
        const { props } = this;
        return (
            props[loadingProp] !== null &&
            props[loadingProp] !== undefined &&
            props[loadingProp] === true
        );
    }

    render() {
        const loadingContent = this.isLoading() ? (<div className={css.loadingContainer}>
            <Spinner />
        </div>) : '';

        return (<div className="has-a-loader">
            {loadingContent}
            <WrappedComponent {...this.props} />
        </div>);
    }
};

export default withLoader;



// WEBPACK FOOTER //
// ./app/components/with-loader/index.js